var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { isMember } from "../../constants";
import * as demand from "./OnDemand";
import * as explZone from "./ExplorationZone";
import * as ExibitionHall from "./ExibitionHall";
import { DisplayOnce, TimeSwitch } from "@tk-events/fw";
var ISFModal = function (content) { return ({
    modalOverrides: {
        dismissHTML: "X",
        dismissStyle: {
            color: "#fff",
            fontSize: "25px"
        },
        style: {
            background: "#8f38de",
            color: "#fff",
            padding: "2em 3.5em",
            borderRadius: "10px",
            textAlign: "center"
        }
    },
    modal: content
}); };
var auditorium = __assign({ width: "11.8%", height: "17.1%", left: "57.4%", top: "58.8%", label: "Auditorium", isExternal: false }, (new Date() < new Date("2022-11-17 08:00:00")
    ? { href: "/Auditorium" }
    : ISFModal(React.createElement(React.Fragment, null,
        React.createElement("h1", null, "The Auditorium is now closed."),
        React.createElement("p", null, "Please view session recordings in our On-Demand rooms, and be sure to visit the Exhibition Hall and ISF Exploration Zone.")))));
var exibition = {
    width: "11.8%",
    height: "18.1%",
    left: "26.4%",
    top: "57.8%",
    label: "Exhibition Hall",
    isExternal: false,
    href: ExibitionHall.location
};
var onDemand = __assign({ width: "6.8%", height: "18.1%", left: "28.4%", top: "37.8%", label: "View presentations from Manchester 2022, ISF World Congress", isExternal: false }, (isMember ? { href: demand.location } : ISFModal(React.createElement("h1", null, "This is a Member\u2019s only area. "))));
var explorationZone = __assign({ width: "11.8%", height: "21.1%", left: "57.4%", top: "14.8%", label: "Exploration Zone", isExternal: false }, (isMember ? { href: explZone.location } : ISFModal(React.createElement("h1", null, "This is a Member\u2019s only area. "))));
var faq = {
    width: "5.8%",
    height: "15.1%",
    left: "23%",
    top: "76.8%",
    label: "FAQ",
    isExternal: true,
    target: "_blank",
    href: "https://isfcongress.tkeventsregistration.com/2022/faqsvirtual"
};
var helpDesk = {
    width: "17.8%",
    height: "20.1%",
    left: "29.6%",
    top: "74.8%",
    label: "Help Desk",
    isExternal: false,
    onClick: function () {
        return;
    }
};
var newsVideo = {
    width: "13.4%",
    height: "15.2%",
    left: "71.6%",
    top: "50.5%",
    label: "Welcome",
    isExternal: false,
    modalOverrides: {
        dismissHTML: "X",
        dismissStyle: {
            color: "#fff",
            fontSize: "25px"
        },
        style: {
            background: "#8f38de",
            color: "#fff",
            padding: "2em 3.5em",
            borderRadius: "10px",
            height: "44%",
            width: "79vh"
        }
    },
    modal: React.createElement("div", { style: { height: "100%", width: "100%" } },
        React.createElement("iframe", { src: "https://player.vimeo.com/video/768690511?h=6c171cd2df&autoplay=1", width: "100%", height: "100%", frameBorder: "0", allow: "autoplay; fullscreen", allowFullScreen: true }))
};
var highlightsManc = {
    width: "11%",
    height: "12.6%",
    left: "14.55%",
    top: "45.6%",
    label: "Highlights from Manchester",
    isExternal: false,
    modalOverrides: {
        dismissHTML: "X",
        dismissStyle: {
            color: "#fff",
            fontSize: "25px"
        },
        style: {
            background: "#8f38de",
            color: "#fff",
            padding: "2em 3.5em",
            borderRadius: "10px",
            height: "44%",
            width: "79vh"
        }
    },
    modal: React.createElement("div", { style: { height: "100%", width: "100%" } },
        React.createElement("iframe", { src: "https://player.vimeo.com/video/769345971?h=e64667f698&autoplay=1", width: "100%", height: "100%", frameBorder: "0", allow: "autoplay;", allowFullScreen: true }))
};
export var body = {
    userData: { eventName: "Test", fullName: "Guilherme Baule", regId: "12313213213213" },
    background: "https://assets.swoogo.com/uploads/full/2199147-6374979640d63.jpg",
    name: "Atrium",
    links: [
        auditorium,
        exibition,
        onDemand,
        explorationZone,
        faq,
        helpDesk,
        newsVideo,
        highlightsManc
    ],
    default: true,
    extras: React.createElement(React.Fragment, null,
        React.createElement(TimeSwitch, null, [
            {
                starts: "2022-10-14 08:45:00 UTC",
                ends: "2022-11-15 07:44:59 UTC",
                id: "welcome",
                content: React.createElement(React.Fragment, null,
                    React.createElement("h1", null, "WELCOME TO MANCHESTER 2022 ONLINE: DAY ONE"),
                    React.createElement("p", null, "Today's keynote speakers are Professor Mo Gawdat and Toomas Ilves."),
                    React.createElement("p", null, "Visit the ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members and tap into the knowledge of the ISF team."),
                    React.createElement("p", null, "Visit the Exhibition Hall to learn how our sponsors can help you optimise managing your security landscape."))
            },
            {
                starts: "2022-11-15 08:45:00 UTC",
                ends: "2022-11-16 07:44:59 UTC",
                id: "welcome-day-two",
                content: React.createElement(React.Fragment, null,
                    React.createElement("h1", null, "WELCOME TO MANCHESTER 2022 ONLINE: DAY TWO"),
                    React.createElement("p", null, "Today's keynote speakers are Omera Khan and Jamie Bartlett."),
                    React.createElement("p", null, "Visit the ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members and tap into the knowledge of the ISF team."),
                    React.createElement("p", null, "Visit the Exhibition Hall to learn how our sponsors can help you optimise managing your security landscape."),
                    React.createElement("p", null, "Go to our on-demand room to view yesterday's sessions."))
            },
            {
                starts: "2022-11-16 08:45:00 UTC",
                ends: "2022-11-16 15:59:59 UTC",
                id: "welcome-day-three",
                content: React.createElement(React.Fragment, null,
                    React.createElement("h1", null, "WELCOME TO MANCHESTER 2022 ONLINE: DAY THREE"),
                    React.createElement("p", null, "Today's keynote speakers are Margaret Heffernan and Rahaf Harfoush."),
                    React.createElement("p", null, "Available now - the new ISF Supplier Security WebApp! Join our session at 10:30 for an overview of the wider ISF Supply Chain Security suite and a focus on the latest addition. "),
                    React.createElement("p", null, "If you haven't already, you can connect one-to-one with the ISF team in the Exploration Zone."),
                    React.createElement("p", null, "Go to our on-demand room to view previous sessions. All sessions will be available to view on-demand after today's broadcast."))
            },
            {
                starts: "2022-11-16 16:00:00 UTC",
                ends: "2022-11-16 16:10:00 UTC",
                id: "end-day-three",
                content: React.createElement(React.Fragment, null,
                    React.createElement("h1", null, "THANK YOU FOR ATTENDING MANCHESTER 2022 ONLINE"),
                    React.createElement("p", null, "CPE certificates for attendance will be issued automatically approximately three weeks after the event. You will receive an email notification and you will also be able to access your certificate from your ISF profile."),
                    React.createElement("p", null, "The Congress venue will remain open until Wednesday 7th December for you to browse content and watch sessions on demand."))
            },
            {
                starts: "2022-11-16 16:10:00 UTC",
                ends: "2023-11-16 17:00:00 UTC",
                id: "end-day-three",
                onceDay: true,
                content: React.createElement(React.Fragment, null,
                    React.createElement("h1", null, "WELCOME TO MANCHESTER 2022 ONLINE: ON-DEMAND"),
                    React.createElement("p", null, "Visit our On-Demand rooms to view session recordings from Congress in Manchester."),
                    React.createElement("p", null, "Don't forget to visit our ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members."),
                    React.createElement("p", null, "Visit the Exhibition Hall to learn how our sponsors can help you optimise managing your security landscape."),
                    React.createElement("p", null, "The Online platform will remain open until the 7th of December, 2022."),
                    React.createElement("p", null, "We look forward to seeing you again in 2023!"))
            }
        ].map(function (row) {
            var style = {
                background: "#8f38de",
                color: "#fff",
                padding: "2em 3.5em",
                borderRadius: "10px"
            };
            var content = React.createElement(DisplayOnce, { id: row.onceDay === true ? "".concat(new Date().toISOString().split("T")[0], "-").concat(row.id) : row.id, dismissHTML: "X", dismissStyle: { color: "#fff", fontSize: "25px" }, style: style }, row.content);
            return __assign(__assign({}, row), { content: content, id: undefined });
        })))
};
export var location = "/Atrium";
